import { render, staticRenderFns } from "./ContactPaginate.vue?vue&type=template&id=1873d4ec&scoped=true&"
import script from "./ContactPaginate.vue?vue&type=script&lang=js&"
export * from "./ContactPaginate.vue?vue&type=script&lang=js&"
import style0 from "./ContactPaginate.vue?vue&type=style&index=0&id=1873d4ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1873d4ec",
  null
  
)

export default component.exports